import { Services_Types_Enum, Meeting_Types_Enum } from "../../Constants";

export const AppHelpers = {
  clickOnEnter,
  svgBase64,
  uuidv4,
  getMeetingNameByIdFromEnum,
  getServiceNameByIdFromEnum,
  isChromium
};

/**
 * Wywołuje klikniecię na elemencie na którym jest focus
 */
function clickOnEnter(event) {
  if (event.key === "Enter") {
    event.target.click();
  }
}

function svgBase64(svgData) {
  return "data:image/svg+xml;base64," + window.btoa(unescape(encodeURIComponent(svgData)));
};

function uuidv4() {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
  );
}

function getMeetingNameByIdFromEnum(id) {
  const meetingType = Object.values(Meeting_Types_Enum).find(type => type.id === id);
  return meetingType ? meetingType.name : null;
}

function getServiceNameByIdFromEnum(id) {
  const meetingType = Object.values(Services_Types_Enum).find(type => type.id === id);
  return meetingType ? meetingType.name : null;
}

/**
 * Funkcja sprawdzająca czy przeglądarka jest oparta na silniku Chromium, co jest istotne dla poprawnego działania inputa typu "month" w przypadku daty urodzenia.
 * Niektóre przeglądarki, takie jak Safari, mają problemy z obsługą inputa typu "month", dlatego w takich przypadkach używamy typu "date" jako alternatywy.
 * @return {boolean} Zwraca true, jeśli przeglądarka jest oparta na silniku Chromium, w przeciwnym razie false.
 */
function isChromium() {
  let ua = navigator.userAgent.toLowerCase();

  const isChromium =
  ua.includes("chrome") ||
  ua.includes("chromium") ||
  ua.includes("edg/") ||
  ua.includes("opr/");

  return isChromium;
}